<template>
  <div class="bill-details page" ref="container">
    <nav-bar
      title="预约记录"
      left-text="返回"
      left-arrow
      right-text="去预约"
      @click-left="goBack"
      @click-right="toAdd"
      :fixed="false"
      :placeholder="true"
    />

    <div class="nav acea-row">
      <div class="item" :class="types == 5 ? 'on' : ''" @click="changeTypes(5)">
        全部
      </div>
      <div class="item" :class="types == 0 ? 'on' : ''" @click="changeTypes(0)">
        待确认
      </div>
      <div class="item" :class="types == 1 ? 'on' : ''" @click="changeTypes(1)">
        待到店
      </div>
      <div class="item" :class="types == 2 ? 'on' : ''" @click="changeTypes(2)">
        已到店
      </div>
      <div class="item" :class="types == 3 ? 'on' : ''" @click="changeTypes(3)">
        服务中
      </div>
      <div class="item" :class="types == 4 ? 'on' : ''" @click="changeTypes(4)">
        已完成
      </div>
      <div
        class="item"
        :class="types == -1 ? 'on' : ''"
        @click="changeTypes(-1)"
      >
        已取消
      </div>
      <div
        class="item"
        :class="types == -2 ? 'on' : ''"
        @click="changeTypes(-2)"
      >
        爽约
      </div>
    </div>
    <div class="list-wrap">
      <div class="item" v-for="item in list" :key="item.id">
        <div class="title">
          <div class="time">
            {{ dayjs.unix(item.created).format("YYYY-MM-DD hh:mm:ss") }}
          </div>
          <div class="status red" v-if="item.status == 0">待确认</div>
          <div class="status blue" v-if="item.status == 1">待到店</div>
          <div class="status blue" v-if="item.status == 2">已到店</div>
          <div class="status blue" v-if="item.status == 3">服务中</div>
          <div class="status green" v-if="item.status == 4">已完成</div>
          <div class="status red" v-if="item.status == -1">已取消</div>
          <div class="status red" v-if="item.status == -2">爽约</div>
        </div>
        <div class="item-info">
          <div class="pictrue">
            <img
              src="@assets/images/def_service.jpg"
              v-if="!item.itemPic"
              class="no-picture"
            />
            <img :src="item.itemPic + '!tmb_130'" v-else />
          </div>
          <div class="info">
            <div class="text">
              <div class="name">{{ formatName(item.itemList) }}</div>
              <!--              <div class="money"> ￥{{ item.price || 0}}</div>-->
            </div>
            <div class="text">
              <div class="attr">预约时间：{{ formatPlanTime(item) }}</div>
            </div>
            <div class="text tools">
              <div class="attr">服务顾问：{{ item.waiterName }}</div>
              <div class="btn-wrap">
                <span
                  class="btn"
                  @click="doReschedule(item)"
                  v-if="item.status == 1"
                  >改约</span
                >
                <span
                  class="btn"
                  @click="docancle(item)"
                  v-if="item.status == 1 || item.status == 0"
                  >取消</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <empty
        description="暂无预约信息~"
        v-if="list.length == 0 && where.page > 1"
      />
    </div>
  </div>
</template>
<script>
import { cancle, fetchPlan } from "@api/plan";
import { NavBar, Toast, Empty } from "vant";
import dayjs from "dayjs";
import { mapGetters } from "vuex";
export default {
  components: {
    NavBar,
    Empty,
  },
  props: {},
  data: function () {
    return {
      dayjs,
      types: 5,
      where: {
        page: 1,
        limit: 5,
      },
      list: [],
      loaded: false,
      loading: false,
    };
  },
  computed: mapGetters(["userInfo"]),
  watch: {
    userInfo: {
      handler() {
        this.getIndex();
      },
    },
    types: function () {
      this.getIndex();
    },
  },
  mounted: function () {
    let that = this;
    that.getIndex();
    that.$scroll(that.$refs.container, () => {
      !that.loading && that.getIndex();
    });
  },
  methods: {
    minToLabel(m) {
      if (m == null) return "";
      const h = Math.floor(m / 60)
        .toString()
        .padStart(2, "0");
      const mm = (m % 60).toString().padStart(2, "0");
      return `${h}:${mm}`;
    },
    formatPlanTime(item) {
      // 新数据用 startMin/endMin，旧数据回退 planTime
      if (item.startMin != null) {
        const date = item.planDate
          ? dayjs(item.planDate).format("YYYY-MM-DD")
          : "";
        return `${date} ${this.minToLabel(item.startMin)}-${this.minToLabel(
          item.endMin
        )}`;
      }
      return item.planTime || "";
    },
    formatDate(time) {
      return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
    },
    formatName(val) {
      if (val) {
        let names = val.map((o) => o.itemName);
        return names.join(",");
      }
      return "";
    },
    changeTypes: function (val) {
      if (val != this.types) {
        this.types = val;
        this.list = [];
        this.where.page = 1;
        this.loaded = false;
        this.loading = false;
      }
    },
    getIndex: function () {
      let that = this;
      this.loading = true;
      Toast.loading({ duration: 0, forbidClick: true, message: "加载中..." });

      if (that.loaded == true) return;
      if (!that.userInfo || !that.userInfo.id) {
        Toast.clear();
        this.loading = false;
        return;
      }

      // status=5 表示全部，后端按 authori-zation 头解析 accountId
      const data = {
        page: that.where.page,
        limit: that.where.limit,
        status: that.types,
      };
      fetchPlan(data)
        .then((res) => {
          const result = res.result || {};
          that.loaded = result.total < that.where.limit;
          that.where.page = that.where.page + 1;
          that.list.push.apply(that.list, result.records || []);
          Toast.clear();
          this.loading = false;
        })
        .catch(() => {
          Toast.clear();
          this.loading = false;
        });
    },
    docancle(item) {
      cancle(item.id).then(() => {
        Toast("预约已取消！");
        this.list = [];
        this.where.page = 1;
        this.loaded = false;
        this.getIndex();
      });
    },
    doReschedule(item) {
      // 改约：跳 AddPlan 带 id，回显后改时段提交调 reschedule
      this.$router.push({ path: "/user/plan/add", query: { id: item.id } });
    },
    toAdd() {
      this.$router.push({ path: "/user/plan/add" });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
/* 状态 tab 8 项：一屏放不下时横向滚动（与小程序端状态条一致） */
.nav {
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  .item {
    flex-shrink: 0;
  }
}
.list-wrap {
  .item {
    background-color: #fff;
    margin-top: 10px;
    font-size: 13px;

    .title {
      border-bottom: 1px solid #f2f2f2;
      display: flex;
      justify-content: space-between;
      padding: 12px 10px 10px;
      .red {
        color: #fc4141;
      }
      .blue {
        color: #1989fa;
      }
      .green {
        color: #1abb1d;
      }
    }

    .item-info {
      display: flex;
      padding: 8px 10px;

      .pictrue {
        width: 66px;
        height: 66px;
        margin-right: 10px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 6px;
        }
      }

      .info {
        flex: 1;

        .tools {
          margin-top: 0;
          .btn-wrap {
            text-align: right;
          }
        }
      }

      .text {
        display: flex;
        justify-content: space-between;
        margin-top: 3px;
        margin-bottom: 5px;
        color: #999;
        .name {
          color: #333;
          font-size: 13px;
        }
        .money {
          color: #fc4141;
        }

        .btn {
          border: 1px solid #999;
          color: #333;
          padding: 4px 15px;
          border-radius: 40px;
          margin-left: 10px;
          font-size: 12px;
          &.red {
            border: 1px solid #fc4141;
            background-color: #fc4141;
            color: #fff;
          }
        }
      }
    }
  }
}
.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 80px;

  .pictrue img {
    width: 207px;
    height: 160px;
  }
}
</style>
